import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import IParamServices from "../IParamServices";
import BaseService from "../base/BaseService";
import { IAddress, ICustomer } from "@/core/model/sys/ICustomer";
import { IPagedParameters, IPagedResult } from "@/core/model/sys/IPagedParameters";
import { ICustomerDocument } from "@/core/model/sys/ICustomerDocument";

export default class CustomerService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public NewCustomerDocument(customer:ICustomer|null)
  {    
    return {
    ModifiedTime:new Date(),
    Active:true,
    Customer:customer,
    Gid:this.NewId,
    RegisterDate: new Date(),
    DocumentDate: null,
    DocumentType:'',
    DocumentName:'',
    Description: null,
    DocumentMime:null,
    DocumentContent:null,
    ModifiedBy: null,
    IsNew:true
    };
  }
  public NewCustomerAddress():IAddress
  {
    return  {          
      Gid	: this.NewId,
      CountryId:0,
      PostalCode:'',
      State:'',
      City:'',
      Street:'',
      NumExt:'',
      NumInt:'',
      Active:true
    };
  }
  public NewCustomer():ICustomer
  {
    return {
      Gid	: this.NewId,
      ParentCustomerGid:null,
      Code:'',
      CustomerTypeId:0,
      CustomerType:null,
      Name:'',
      LastName:'',	
      MiddleName:'',	
      Phone:'',	
      Comments:'',	
      ModifiedByEmployee:null,
      ModifiedTime: new Date(),
      Usuarios:[],
      Socio:null,
      Addresses:[
        {          
          Gid	: this.NewId,
          CountryId:0,
          PostalCode:'',
          State:'',
          City:'',
          Street:'',
          NumExt:'',
          NumInt:'',
          Active:true
        }
      ],	
      Active: true,
      Deleted: false,
      IsNew: true
    };
  }
  public async GetDocument(id:any)
  {
    let response:IServiceResponse|null = null;
    response = await this.Get('IndexCustomer/GetDocument/' + id,null,null,null,true,undefined,'arraybuffer' );
    return response;
  }
  public async CustomerDocument(id:string):Promise<ICustomerDocument|null>
  {    
    const response:IServiceResponse = await this.Get('IndexCustomer/CustomerDocument/' + id,null,null,null,true,false,null);  
    if(response.Response)
    {      
      return response.Response;
    }            
    return null;
  }
  public async GetCustomer(id:string):Promise<ICustomer|null>
  {    
    const response:IServiceResponse = await this.Get('IndexCustomer/GetCustomer/' + id,null,null,null,true,false,null);  
    if(response.Response)
    {      
      return response.Response;
    }            
    return null;
  }
  public async ListCustomerPaged(paged:IPagedParameters,filter?:string):Promise<IPagedResult<ICustomer>>
  {
    const result: IPagedResult<ICustomer> = {
      Paged:null,
      Result:[]
    }    
    const filters = {
      Page: paged.Page,      
      Search: filter
    }  
    const response:IServiceResponse = await this.Post('IndexCustomer/ListCustomerPaged',filters,null,null,null,true,false,null); 
    if(response)
    {
      result.Paged = response.Paged;
      result.Result = response.Response? response.Response:[];
    }                
    return result;
  } 
  
  public async SearchCustomerHome(query:string):Promise<ICustomer[]>
  {
    const list = Array<ICustomer>();
    const response:IServiceResponse = await this.Get('IndexCustomer/SearchCustomerHome/'+ query,null,null,null,true,false,null);  
    if(response.Response)
    {
      for (const element of response.Response)
      {
        list.push({...element});  
      }
    }        
    return list;
  }   
  public async SearchCustomer(query:string):Promise<ICustomer[]>
  {
    const list = Array<ICustomer>();
    const response:IServiceResponse = await this.Get('IndexCustomer/SearchCustomer/'+ query,null,null,null,true,false,null);  
    if(response.Response)
    {
      for (const element of response.Response)
      {
        list.push({...element});  
      }
    }        
    return list;
  }   
  
  public async SaveCustomer(customerData:ICustomer) : Promise<ICustomer>
  {        
    let response:IServiceResponse|null = null;
    const customer = {...customerData};
    customer.ModifiedByEmployee = null;
    response = await this.Post('IndexCustomer/SaveCustomer',customer,null,null,null,true,false,null);
    if(response && response.Response)
    {      
      if(response.Response.Error)
      {
        customer.Active = false;
        customer.Comments = response.Response.Response;  
      }
      else
      {
        customer.Code = response.Response.CustomerDto? response.Response.CustomerDto.Code:'';
        customer.Active = true;
        customer.Comments = '';  
      }
    }
    return customer;
  }
  public async SaveCustomerDocument(customerData:ICustomerDocument) : Promise<ICustomerDocument>
  {
    let response:IServiceResponse|null = null;
    const customerDocument = {...customerData};    
    response = await this.Post('IndexCustomer/SaveCustomerDocument',customerDocument,null,null,null,true,false,null);
    if(response && response.Response)
    {      
      if(response.Response.Error)
      {
        customerDocument.Active = false;
        customerDocument.Description = response.Response.Response;  
      }
      else
      {        
        customerDocument.Active = true;
        customerDocument.Description = '';  
      }
    }
    return customerDocument;
  }  
  public async CustomerDocuments(id:string):Promise<ICustomerDocument[]>
  {
    const list = Array<ICustomerDocument>();
    const response:IServiceResponse = await this.Get('IndexCustomer/CustomerDocuments/'+ id,null,null,null,true,false,null);  
    if(response.Response)
    {
      for (const element of response.Response)
      {
        list.push({...element});  
      }
    }        
    return list;
  }    
}